<div class="ng-tour-loader sk-fading-circle-container">
    <div class="sk-fading-circle ng-sk-fading-circle">
        <div class="sk-circle sk-circle-1"></div>
        <div class="sk-circle sk-circle-2"></div>
        <div class="sk-circle sk-circle-3"></div>
        <div class="sk-circle sk-circle-4"></div>
        <div class="sk-circle sk-circle-5"></div>
        <div class="sk-circle sk-circle-6"></div>
        <div class="sk-circle sk-circle-7"></div>
        <div class="sk-circle sk-circle-8"></div>
        <div class="sk-circle sk-circle-9"></div>
        <div class="sk-circle sk-circle-10"></div>
        <div class="sk-circle sk-circle-11"></div>
        <div class="sk-circle sk-circle-12"></div>
    </div>
</div>